import Logo from "./Logo";

interface AuthContainerProps {
  children: React.ReactNode;
}

export const AuthContainer = ({ children }: AuthContainerProps) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#00C1D6] to-[#2D6970] p-6">
      <div className="w-full max-w-md space-y-6 animate-fade-in">
        <div className="text-center">
          <Logo />
          <h1 className="text-4xl font-bold text-white mb-2 tracking-wide" style={{ fontFamily: "'Zen Dots', cursive" }}>
            CLUBBERS
          </h1>
        </div>
        <div className="bg-white/10 backdrop-blur-md p-8 rounded-2xl shadow-2xl border border-white/20 ring-1 ring-white/10">
          {children}
        </div>
      </div>
    </div>
  );
};